"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchConvAiSettingsRequest = void 0;
var PatchConvAiSettingsRequest_1 = require("./PatchConvAiSettingsRequest");
Object.defineProperty(exports, "PatchConvAiSettingsRequest", { enumerable: true, get: function () { return PatchConvAiSettingsRequest_1.PatchConvAiSettingsRequest; } });
